import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {TemplateComponent} from "../template/template.component";
import {BaseListComponent} from "../base-list/base-list.component";
import {EFilterType, ITableConfig} from "../../../interface/table.config";
import {CrudService} from "../service/crud.service";
import {ICrudRes} from "../../../interface/http.config";
import {NgIf} from "@angular/common";
import {Router} from "@angular/router";
import {CrudListModel} from "../../../model/crud-list.model";
import {listFromMap, valueFromList} from "../../../helper/list.helper";
import {ECrudFilterType} from "../../../interface/crud.filter-type.enum";

@Component({
  selector: 'app-coupon',
  standalone: true,
  imports: [
    TemplateComponent,
    BaseListComponent,
    NgIf
  ],
  templateUrl: './coupon.component.html',
  styleUrl: './coupon.component.scss'
})
export class CouponComponent extends CrudListModel implements OnInit {

  override editLink = '/dashboard/coupon-edit/';
  override addLink = '/dashboard/coupon-create';

  clientList: Record<string, string> = {};
  clientListMap: {value: string, label: string}[] = [];

  constructor(crudService: CrudService,
              protected cdr: ChangeDetectorRef,
              router: Router) {

    super(crudService, router);

    this.crudService.setProvider('coupon');

  }

  protected tableConfig: ITableConfig = {
    cells: [
      {
        header: 'id',
        field: 'id',
        sortable: true,
        filterType: EFilterType.TEXT,
        crudFilterType: ECrudFilterType.EXACT,
      },
      {
        header: 'Key',
        field: 'key',
        sortable: true,
        filterType: EFilterType.TEXT,
        crudFilterType: ECrudFilterType.EXACT,
      },
      {
        header: 'Total Amount',
        field: 'total',
        sortable: true,
        filterType: EFilterType.TEXT,
        crudFilterType: ECrudFilterType.EXACT,
      },
      {
        header: 'Goal Amount',
        field: 'goal',
        sortable: true,
        filterType: EFilterType.TEXT,
        crudFilterType: ECrudFilterType.EXACT,
      },
    ],
    actions: [
      'edit',
      'delete',
    ]
  };

  ngOnInit() {
    this.update();

    this.crudService.getList('client', 'id', 'email').then(data => {
      this.clientList = data;
      this.clientListMap = listFromMap(data);

      this.cdr.detectChanges();
    });
  }
}
